import { createSelector } from 'reselect'

import { FetchInfo, FetchInfoWithoutId } from 'types';

const getFetchedState = (fetchInfo: FetchInfo, type: string, id: string) => Boolean(fetchInfo && fetchInfo[type] && fetchInfo[type][id]?.fetched);
export const makeGetFetchedState = () => createSelector(getFetchedState, fetched => fetched);

const getErrorState = (fetchInfo: FetchInfo, type: string, id: string) => Boolean(fetchInfo && fetchInfo[type] && fetchInfo[type][id]?.error);
export const makeGetErrorState = () => createSelector(getErrorState, error => error);

const getLoadingState = (fetchInfo: FetchInfo, type: string, id: string) => Boolean(fetchInfo && fetchInfo[type] && fetchInfo[type][id]?.loading);
export const makeGetLoadingState = () => createSelector(getLoadingState, loading => loading);

const getFetchedStateWithoutId = (fetchInfo: FetchInfoWithoutId, type: string) => Boolean(fetchInfo && fetchInfo[type].fetched);
export const makeGetFetchedStateWithoutId = () => createSelector(getFetchedStateWithoutId, fetched => fetched);

const getLoadingStateWithoutId = (fetchInfo: FetchInfoWithoutId, type: string) => Boolean(fetchInfo && fetchInfo[type].loading);
export const makeGetLoadingStateWithoutId = () => createSelector(getLoadingStateWithoutId, loading => loading);

const getHasBefore = (fetchInfo: FetchInfo, type: string, id: string) => Boolean(fetchInfo && fetchInfo[type] && fetchInfo[type][id]?.hasBefore);
export const makeGetHasBefore = () => createSelector(getHasBefore, hasBefore => hasBefore);

const getHasAfter = (fetchInfo: FetchInfo, type: string, id: string) => Boolean(fetchInfo && fetchInfo[type] && fetchInfo[type][id]?.hasAfter);
export const makeGetHasAfter = () => createSelector(getHasAfter, hasAfter => hasAfter);

const getHasMore = (fetchInfo: FetchInfo, type: string, id: string) => Boolean(fetchInfo && fetchInfo[type] && fetchInfo[type][id]?.hasMore);
export const makeGetHasMore = () => createSelector(getHasMore, hasMore => hasMore);

const getHasMoreWithoutId = (fetchInfo: FetchInfoWithoutId, type: string) => Boolean(fetchInfo && fetchInfo[type].hasMore);
export const makeGetHasMoreWithoutId = () => createSelector(getHasMoreWithoutId, hasMore => hasMore);
